import {createSelector} from 'reselect';
import {getStart} from '../selectors';

const getOptionalPaymentDetailsConsentTranslationKey = paymentMethodType => createSelector(
  [getStart],
  start => Object.entries(start.optionalConsentConfiguration)
    .find(consent => consent[0] === paymentMethodType)?.[1],
);

export default getOptionalPaymentDetailsConsentTranslationKey;
